module.exports = __webpack_public_path__ + "img/Badge.5663cbd3.svg";